// extracted by mini-css-extract-plugin
export default {"dialogContent":"SendToSingleUser_dialogContent__5xFvX"};